import React, {createRef} from 'react';
import classnames from 'classnames';
import DocTitle from './contentShumaType2/DocTitle';
import DocProps from './contentShumaType2/DocProps';
import Title from './contentShumaType2/Title';
import GreenBox from './contentShumaType2/GreenBox';
import Section1 from './contentShumaType2/Section1';
import Section2Title from './contentShumaType2/Section2Title';
import Section2Text from './contentShumaType2/Section2Text';
import PlansCheckDate from './contentShumaType2/PlansCheckDate';
import Section3 from './contentShumaType2/Section3';
import Table from './contentShumaType2/Table';
import {getShumaType2and3MortgageEntityEmphasis} from './contentShumaType2/MortgageEntityEmphasis';
import Section5Title from './contentShumaType2/Section5Title';
import Section5TextContent, {
  FacingText,
  getAreaLimitText,
  getAreaFeatures,
  getEnvDevelopmentLevel,
  PropertyLocationDescText,
} from './contentShumaType2/Section5TextContent';
import MapImageWithText from './contentShumaType2/MapImageWithText';
import Section6Title from './contentShumaType2/Section6Title';
import Section6Text1 from './contentShumaType2/Section6Text1';
import Section6Text2 from './contentShumaType2/Section6Text2';
import Section6Text0 from "./contentShumaType2/Section6Text0";
import Section6Text3 from "./contentShumaType2/Section6Text3";
import {getAdjacentStreets} from './contentShumaType2/SectionAdjacentStreets';
import SatelliteImageWithText from './contentShumaType2/SatelliteImageWithText';
import SchemeImageWithText from './contentShumaType2/SchemeImageWithText';
import SelectedLandsTexts from './contentShumaType2/SelectedLandsTexts';
import Section6Text71 from './contentShumaType2/Section6Text71';
import Section6Text71a from './contentShumaType2/Section6Text71a';
import Section6Text72 from './contentShumaType2/Section6Text72';
import Section6Text73 from './contentShumaType2/Section6Text73';
import Section6Text74 from './contentShumaType2/Section6Text74';
import Section6Text75 from './contentShumaType2/Section6Text75';
import Section6Text76 from './contentShumaType2/Section6Text76';
import {getSection6Text77} from './contentShumaType2/Section6Text77';
import Section6Text78 from './contentShumaType2/Section6Text78';
import Section6Text78a from './contentShumaType2/Section6Text78a';
import Section6Text78b from './contentShumaType2/Section6Text78b';
import Section6Text78c from './contentShumaType2/Section6Text78c';
import Section6Text78d from './contentShumaType2/Section6Text78d';
import Section6Text78e from './contentShumaType2/Section6Text78e';
import {getSection6Text79} from './contentShumaType2/Section6Text79';
import Section6Text710 from './contentShumaType2/Section6Text710';
import Section6Text711 from './contentShumaType2/Section6Text711';
import Section6Text712 from './contentShumaType2/Section6Text712';
import Section6Text713 from './contentShumaType2/Section6Text713';
import Section6Text713a from './contentShumaType2/Section6Text713a';
import {getSection6Text714} from './contentShumaType2/Section6Text714';
import Section6HouseAttributes from './contentShumaType2/Section6HouseAttributes';
import Page6TextContentItems1and2 from './contentShumaType2/Page6TextContentItems1and2';
import Page6TextContentItemsFrom4to14 from './contentShumaType2/Page6TextContentItemsFrom4to14';
import Page6TextContentItem16 from './contentShumaType2/Page6TextContentItem16';
import Page6TextItem19 from './contentShumaType2/Page6TextContentItem19';
import Page6TextItem20 from './contentShumaType2/Page6TextContentItem20';
import BuildingPopulatedText from './contentShumaType2/BuildingPopulatedText';
import BuildingRoofTypeText from './contentShumaType2/BuildingRoofTypeText';
import BuildingPermit from './contentShumaType2/BuildingPermit';
import GoogleViewImageWithLabel from './contentShumaType2/GoogleViewImageWithLabel';
import {getTypicalFloorPlanFiles} from './contentShumaType2/TypicalFloorPlanFiles';
import {getPropertyIdentification} from './contentShumaType2/PropertyIdentification';
import {getFloors} from './contentShumaType2/Floors';
import {getFloors as getFloorsTypeId33} from './contentShumaType2/FloorsID33';
import {getSection7} from './contentShumaType2/Section7';
import getValidLocalPlansDetailsSection from './contentShumaType2/ValidLocalPlansDetailsSection';
import getCountryStateDataSection from './contentShumaType2/CountryStateDataSection';
import getPlansInProgressSection from './contentShumaType2/PlansInProgressSection';
import {getLicensingSection} from './contentShumaType2/LicensingSection';
import {getSupervisionSection} from './contentShumaType2/SupervisionSection';
import {
  getForm4,
  getCompleteCert,
  getDangerousStructure
} from './contentShumaType2/Page19AttachedFiles';
import {getSection8} from './contentShumaType2/Section8';
import Section8Title from './contentShumaType2/Section8Title';
import Section8Text1 from './contentShumaType2/Section8Text1';
import Section8Text2 from './contentShumaType2/Section8Text2';
import Section8Text3 from './contentShumaType2/Section8Text3';
import Section8Text4 from './contentShumaType2/Section8Text4';
import Section8Text5 from './contentShumaType2/Section8Text5';
import Section8Text6 from './contentShumaType2/Section8Text6';
import Section8Text7 from './contentShumaType2/Section8Text7';
import Section8Text8 from './contentShumaType2/Section8Text8';
import Section8Text9 from './contentShumaType2/Section8Text9';
import Section8Text10 from './contentShumaType2/Section8Text10';
import Section8Text11 from './contentShumaType2/Section8Text11';
import Section8Text12 from './contentShumaType2/Section8Text12';
import Section8Text13 from './contentShumaType2/Section8Text13';
import Section8Text14 from './contentShumaType2/Section8Text14';
import Section8Text15 from './contentShumaType2/Section8Text15';
import Section8Text16 from './contentShumaType2/Section8Text16';
import Section8Text17 from './contentShumaType2/Section8Text17';
import Section8Text18 from './contentShumaType2/Section8Text18';
import Section8Text19 from './contentShumaType2/Section8Text19';
import Section8Text20 from './contentShumaType2/Section8Text20';
import Section8Text21 from './contentShumaType2/Section8Text21';
import Section8Text22 from './contentShumaType2/Section8Text22';
import Section8Text23 from './contentShumaType2/Section8Text23';
import Section8Text24 from './contentShumaType2/Section8Text24';
import Section8Text25 from './contentShumaType2/Section8Text25';
import {getStep5MediaFiles} from './contentShumaType2/Step5MediaFiles';
import {getShumaType2Section9} from './contentShumaType2/ShumaType2Section9';
import {getShumaType2FilesList} from './contentShumaType2/FilesList';
import {getSelectedRowsAndColumnsTables} from './contentShumaType2/SelectedRowsAndColumnsTables';
import CalculationTables from './contentShumaType2/CalculationTables';
import ShumaType2Section10Title from './contentShumaType2/Section10Title';
import Section10Text from './contentShumaType2/Section10Text';
import FinalPrice from './contentShumaType2/FinalPrice';
import {getCalculationNotesText} from './contentShumaType2/CalculationNotesText';
import GrayBox from './contentShumaType2/GrayBox';
import Signature from './contentShumaType2/Signature';
import LastPage from './contentShumaType2/LastPage';
import {
  CommentRegisteredArea,
  CommentSurveyArea,
  CommentLandShapeValueText,
  CommentBuildingPhysicalStateValue,
  CommentBuildPermitNotSigned,
  CommentPermitAndExistingAreaComparisonText,
  CommentHousePhysicalStateValue,
  CommentSection7,
  CommentEstimateText,
  CommentPropertyBuildCostEstimate,
  CommentPriceDelta,
  CommentBettermentTax,
  CommentRamiCost,
  CommentRealizeCost
} from './contentShumaType2/Comments';
import {findFileByTypeId} from '../../utils/files';
import styles from './styles.module.scss';

let i = 0;

const mapItem = ({refs, id, getClassName}) => (item, index, array) => {
  const Component = React.forwardRef(({}, ref) => (
    <div
      ref={ref}
      data-testid={id}
      className={Boolean(getClassName) ? getClassName({index, array}) : ''}
    >
      {item}
    </div>
  ));

  return <Component ref={addRef(refs)} key={i++}/>;
};

export const getContentAndRefs = (context) => {
  let refs = [];
  const content = [
    <DocTitle ref={addRef(refs)} key={i++}/>,
    <DocProps ref={addRef(refs)} key={i++}/>,
    <Title ref={addRef(refs)} key={i++}/>,
    <GreenBox ref={addRef(refs)} key={i++}/>,
    <Section1 ref={addRef(refs)} key={i++}/>,
    <Section2Title ref={addRef(refs)} key={i++}/>,
    <Section2Text ref={addRef(refs)} key={i++}/>,
    <PlansCheckDate ref={addRef(refs)} key={i++}/>,
    <Section3 ref={addRef(refs)} key={i++}/>,
    <Table ref={addRef(refs)} key={i++}/>,
    ...getShumaType2and3MortgageEntityEmphasis(context).map(mapItem({
      refs,
      id: 'section4MortgageEntityEmphasis'
    })),
    <Section5Title ref={addRef(refs)} key={i++}/>,
    <PropertyLocationDescText ref={addRef(refs)} key={i++}/>,
    <FacingText ref={addRef(refs)} key={i++}/>,
    ...getAreaLimitText(context).map(mapItem({
      refs,
      id: 'areaLimit'
    })),
    ...getAreaFeatures(context).map(mapItem({
      refs,
      id: 'areaFeatures'
    })),
    ...Section5TextContent.map((TextItem) => (
      <TextItem ref={addRef(refs)} key={i++}/>
    )),
    ...getEnvDevelopmentLevel(context).map(mapItem({
      refs,
      id: 'envDevelopmentLevel'
    })),
    ...getAdjacentStreets(context).map(mapItem({
      refs,
      id: 'adjacentStreets'
    })),
    <MapImageWithText ref={addRef(refs)} key={i++}/>,
    <Section6Title ref={addRef(refs)} key={i++}/>,
    <Section6Text0 ref={addRef(refs)} key={i++}/>,
    <Section6Text1 ref={addRef(refs)} key={i++}/>,
    <Section6Text2 ref={addRef(refs)} key={i++}/>,
    <Section6Text3 ref={addRef(refs)} key={i++}/>,
    <SatelliteImageWithText ref={addRef(refs)} key={i++}/>,
    <SchemeImageWithText ref={addRef(refs)} key={i++}/>,
    ...SelectedLandsTexts.map((LandTextItem) => (
      <LandTextItem ref={addRef(refs)} key={i++}/>
    )),
    ...Page6TextContentItems1and2.map((TextItem) => (
      <TextItem ref={addRef(refs)} key={i++}/>
    )),
    <BuildingPopulatedText ref={addRef(refs)} key={i++}/>,
    ...Page6TextContentItemsFrom4to14.map((TextItem) => (
      <TextItem ref={addRef(refs)} key={i++}/>
    )),
    <BuildingRoofTypeText ref={addRef(refs)} key={i++}/>,
    ...Page6TextContentItem16.map((TextItem) => (
      <TextItem ref={addRef(refs)} key={i++}/>
    )),
    <BuildingPermit ref={addRef(refs)} key={i++}/>,
    <Page6TextItem19 ref={addRef(refs)} key={i++}/>,
    <Page6TextItem20 ref={addRef(refs)} key={i++}/>,
    <GoogleViewImageWithLabel ref={addRef(refs)} key={i++}/>,
    <Section6Text71 ref={addRef(refs)} key={i++}/>,
    <Section6Text71a ref={addRef(refs)} key={i++}/>,
    <Section6Text72 ref={addRef(refs)} key={i++}/>,
    <Section6Text73 ref={addRef(refs)} key={i++}/>,
    <Section6Text74 ref={addRef(refs)} key={i++}/>,
    <Section6Text75 ref={addRef(refs)} key={i++}/>,
    <Section6Text76 ref={addRef(refs)} key={i++}/>,
    ...getSection6Text77(context).map(mapItem({
      refs,
      id: 'housePermitArea'
    })),
    <Section6Text78 ref={addRef(refs)} key={i++}/>,
    <Section6Text78a ref={addRef(refs)} key={i++}/>,
    <Section6Text78b ref={addRef(refs)} key={i++}/>,
    <Section6Text78c ref={addRef(refs)} key={i++}/>,
    <Section6Text78d ref={addRef(refs)} key={i++}/>,
    <Section6Text78e ref={addRef(refs)} key={i++}/>,
    ...getSection6Text79(context).map(mapItem({
      refs,
      id: 'houseMaintenanceStatusText'
    })),
    <Section6Text710 ref={addRef(refs)} key={i++}/>,
    <Section6Text711 ref={addRef(refs)} key={i++}/>,
    <Section6Text712 ref={addRef(refs)} key={i++}/>,
    <Section6Text713 ref={addRef(refs)} key={i++}/>,
    <Section6Text713a ref={addRef(refs)} key={i++}/>,
    ...getSection6Text714(context).map(mapItem({
      refs,
      id: 'houseFunctionalDivide'
    })),
    ...Section6HouseAttributes.map((Item) => (
      <Item ref={addRef(refs)} key={i++}/>
    )),
    ...getTypicalFloorPlanFiles(context).map(mapItem({
      refs,
      id: 'getTypicalFloorPlanFiles'
    })),
    ...getPropertyIdentification(context).map(mapItem({
      refs,
      id: 'getPropertyIdentification',
      getClassName: ({index}) => classnames(styles.pageHeight, {
        [styles.smallerHeight]: index === 0,
      })
    })),
    ...getFloorsTypeId33(context, 33, 'שרטוט הנכס:')
      .map(mapItem({
        refs,
        id: 'getFloors',
        getClassName: ({index, array}) => classnames({
          [styles.mb5]: index === array.length - 1
        })
      })),
    ...getFloors(context)
      .map(mapItem({
        refs,
        id: 'getFloors',
        getClassName: ({index, array}) => classnames({
          [styles.mb5]: index === array.length - 1
        })
      })),
    ...getSection7(context).map((page, index) => {
      const fileTypeID = 14;
      const file = findFileByTypeId(context.files, fileTypeID);
      const Component = React.forwardRef(({}, ref) => (
        <div
          ref={ref}
          className={classnames({
            [styles.pageHeight]: Boolean(file),
            [styles.smallerHeight]: index === 0,
          })}
        >
          {page}
        </div>
      ));

      return <Component ref={addRef(refs)} key={i++}/>;
    }),
    ...getValidLocalPlansDetailsSection(context).map(mapItem({
      refs,
      id: 'getValidLocalPlansDetailsSection'
    })),
    ...getCountryStateDataSection(context).map(mapItem({
      refs,
      id: 'getCountryStateDataSection'
    })),
    ...getPlansInProgressSection(context).map(mapItem({
      refs,
      id: 'getPlansInProgressSection'
    })),
    ...getLicensingSection(context).map(mapItem({
      refs,
      id: 'LicensingSection',
      getClassName: () => classnames(styles.pageHeight)
    })),
    ...getSupervisionSection(context).map(mapItem({
      refs,
      id: 'SupervisionSection',
      getClassName: () => classnames(styles.pageHeight)
    })),
    ...getForm4(context).map(mapItem({
      refs,
      id: 'getForm4'
    })),
    ...getCompleteCert(context).map(mapItem({
      refs,
      id: 'getCompleteCert',
      getClassName: () => classnames(styles.pageHeight)
    })),
    ...getDangerousStructure(context).map(mapItem({
      refs,
      id: 'getDangerousStructure',
      getClassName: () => classnames(styles.pageHeight)
    })),
    <Section8Title ref={addRef(refs)} key={i++}/>,
    <Section8Text1 ref={addRef(refs)} key={i++}/>,
    <Section8Text2 ref={addRef(refs)} key={i++}/>,
    <Section8Text3 ref={addRef(refs)} key={i++}/>,
    <Section8Text4 ref={addRef(refs)} key={i++}/>,
    <Section8Text5 ref={addRef(refs)} key={i++}/>,
    <Section8Text6 ref={addRef(refs)} key={i++}/>,
    <Section8Text7 ref={addRef(refs)} key={i++}/>,
    <Section8Text8 ref={addRef(refs)} key={i++}/>,
    <Section8Text9 ref={addRef(refs)} key={i++}/>,
    <Section8Text10 ref={addRef(refs)} key={i++}/>,
    <Section8Text11 ref={addRef(refs)} key={i++}/>,
    <Section8Text12 ref={addRef(refs)} key={i++}/>,
    <Section8Text13 ref={addRef(refs)} key={i++}/>,
    <Section8Text14 ref={addRef(refs)} key={i++}/>,
    <Section8Text15 ref={addRef(refs)} key={i++}/>,
    <Section8Text16 ref={addRef(refs)} key={i++}/>,
    <Section8Text17 ref={addRef(refs)} key={i++}/>,
    ...getSection8(context).map((page, index) => {
      const fileTypeID = 1;
      const file = findFileByTypeId(context.files, fileTypeID);
      const Component = React.forwardRef(({}, ref) => (
        <div
          ref={ref}
          className={classnames({
            [styles.pageHeight]: Boolean(file),
            [styles.smallerHeight720]: index === 0
          })}
        >
          {page}
        </div>
      ));

      return <Component ref={addRef(refs)} key={i++}/>;
    }),
    <Section8Text18 ref={addRef(refs)} key={i++}/>,
    <Section8Text19 ref={addRef(refs)} key={i++}/>,
    <Section8Text20 ref={addRef(refs)} key={i++}/>,
    <Section8Text21 ref={addRef(refs)} key={i++}/>,
    ...getStep5MediaFiles(context).map(mapItem({
      refs,
      id: 'getStep5MediaFiles',
      getClassName: () => classnames(styles.pageHeight)
    })),
    <Section8Text22 ref={addRef(refs)} key={i++}/>,
    <Section8Text23 ref={addRef(refs)} key={i++}/>,
    <Section8Text24 ref={addRef(refs)} key={i++}/>,
    <Section8Text25 ref={addRef(refs)} key={i++}/>,
    ...getShumaType2FilesList(context).map(mapItem({
      refs,
      id: 'filesList',
      getClassName: () => classnames(styles.pageHeight)
    })),
    ...getShumaType2Section9(context).map(mapItem({
      refs,
      id: 'section9',
      getClassName: () => classnames(styles.pageHeight)
    })),
    ...getSelectedRowsAndColumnsTables(context).map(mapItem({
      refs,
      id: 'selectedRowsAndColumnsTables',
      getClassName: () => classnames(styles.pageHeight)
    })),
    <CalculationTables ref={addRef(refs)} key={i++}/>,
    <ShumaType2Section10Title ref={addRef(refs)} key={i++}/>,
    <Section10Text ref={addRef(refs)} key={i++}/>,
    <FinalPrice ref={addRef(refs)} key={i++}/>,
    ...getCalculationNotesText(context).map(mapItem({
      refs,
      id: 'calculationNotesText',
    })),
    <GrayBox ref={addRef(refs)} key={i++}/>,
    <Signature ref={addRef(refs)} key={i++}/>,
    <LastPage ref={addRef(refs)} key={i++}/>,
  ];

  let commentRefs = {};
  const commentsContent = {
    registeredArea: (
      <CommentRegisteredArea
        ref={addNoteRef(commentRefs, 'registeredArea')}
        key={i++}
      />
    ),
    surveyArea: (
      <CommentSurveyArea
        ref={addNoteRef(commentRefs, 'surveyArea')}
        key={i++}
      />
    ),
    landShapeValueText: (
      <CommentLandShapeValueText
        ref={addNoteRef(commentRefs, 'landShapeValueText')}
        key={i++}
      />
    ),
    buildingPhysicalStateValue: (
      <CommentBuildingPhysicalStateValue
        ref={addNoteRef(commentRefs, 'buildingPhysicalStateValue')}
        key={i++}
      />
    ),
    buildPermitNotSigned: (
      <CommentBuildPermitNotSigned
        ref={addNoteRef(commentRefs, 'buildPermitNotSigned')}
        key={i++}/>
    ),
    permitAndExistingAreaComparisonText:
      (
        <CommentPermitAndExistingAreaComparisonText
          ref={addNoteRef(commentRefs, 'permitAndExistingAreaComparisonText')}
          key={i++}
        />
      ),
    housePhysicalStateValue: (
      <CommentHousePhysicalStateValue
        ref={addNoteRef(commentRefs, 'housePhysicalStateValue')}
        key={i++}
      />
    ),
    section7: (
      <CommentSection7
        ref={addNoteRef(commentRefs, 'section7')}
        key={i++}
      />
    ),
    estimateText: (
      <CommentEstimateText
        ref={addNoteRef(commentRefs, 'estimateText')}
        key={i++}
      />
    ),
    propertyBuildCostEstimate: (
      <CommentPropertyBuildCostEstimate
        ref={addNoteRef(commentRefs, 'propertyBuildCostEstimate')}
        key={i++}
      />
    ),
    priceDelta: (
      <CommentPriceDelta
        ref={addNoteRef(commentRefs, 'priceDelta')}
        key={i++}
      />
    ),
    bettermentTax: (
      <CommentBettermentTax
        ref={addNoteRef(commentRefs, 'bettermentTax')}
        key={i++}
      />
    ),
    ramiCost: (
      <CommentRamiCost
        ref={addNoteRef(commentRefs, 'ramiCost')}
        key={i++}
      />
    ),
    realizeCost: (
      <CommentRealizeCost
        ref={addNoteRef(commentRefs, 'realizeCost')}
        key={i++}
      />
    ),
  };

  return {content, refs, commentsContent, commentRefs};
};

const addRef = refs => element => {
  refs.push(element);
};

const addNoteRef = (refs, id) => {
  const ref = createRef();
  refs[id] = ref;
  return ref;
};